// P6 Audio Locations shared Alpine behavior.
// Included by both legacy (new_page.js) and modern (new_new_page.js) packs.
// Bitrate/conversion machinery was removed for the pinned-128 contract; only
// the occupied-slot replacement helpers remain.

export function mapPlacementEpisode(episode) {
    return {
        id: episode[0],
        title: episode[1],
        episode_season: episode[2],
        episode_number: episode[3],
        episode_stage: episode[4],
        content: episode[5] === undefined ? [] : episode[5]
    }
}

export function conversionAlertAlpine() {
    return {
        replacement_banner_collapsed: false,
        // P6 occupied-slot UI: an ':add' entry on a slot that already has content
        // is a pending replacement (old ad removed, new ad assigned on save).
        pending_replacements() {
            return this.content_insertions
                .filter((entry) => entry.endsWith(':add'))
                .map((entry) => {
                    const parts = entry.split(':')
                    const episode = this.episode_data.find((e) => String(e.id) === parts[0])
                    if (!episode) return null
                    const occupied = parts[1] === 'pre_roll'
                        ? this.display_pre_content(episode)[0]
                        : this.display_post_content(episode)[0]
                    if (occupied.placement === null) return null
                    // On the edit page, a slot already holding the CI being edited
                    // is a re-affirm, not a replacement.
                    if (occupied.content_id != null && this.content_insertion_id != null &&
                        String(occupied.content_id) === String(this.content_insertion_id)) return null
                    return {
                        key: entry,
                        episode_id: episode.id,
                        title: episode.title,
                        ref: this.format_episode_season(episode),
                        placement: parts[1].replace('_', '-'),
                        content_name: occupied.content_name
                    }
                })
                .filter(Boolean)
        },
        replacement_summary() {
            // Counts unique episodes: one episode with both pre and post pending
            // still reads as a single episode in the banner copy.
            const count = new Set(this.pending_replacements().map((i) => i.episode_id)).size
            return `${count} episode${count === 1 ? ' already has' : 's already have'} existing content – replace them?`
        },
        keep_existing(key) {
            // Opt out: un-check the slot; the occupied ad stays and the row leaves the banner.
            this.content_insertions = this.content_insertions.filter((entry) => entry !== key)
        }
    }
}

// Copies data, methods, and getters onto the Alpine component. Object spread
// would evaluate getters once; defineProperties keeps them live.
export function withConversionAlert(component) {
    return Object.defineProperties(
        component,
        Object.getOwnPropertyDescriptors(conversionAlertAlpine())
    )
}
